var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"logo",class:{
    global: _vm.$isEn
  }},[_c('a',{staticClass:"link_logo",on:{"click":function($event){$event.stopPropagation();return _vm.gotoHome($event)}}},[_c('span',{staticClass:"blind"},[_vm._v("comico")])])])}
var staticRenderFns = []

export { render, staticRenderFns }